<template>
    <div class="pricing-header">
        <div class="content">
            <p class="title">AMAZING LOGO</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PricingHeader'
    }
</script>

<style lang="scss">
    .pricing-header {
        position: absolute;
        top: 0;
        width: 100%;
        height: 350px;
        background-color: #EDC569;
        padding-bottom: 50px;
        box-sizing: border-box;

        .content {
            height: 100%;
            max-width: 784px;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .title {
                margin: 0;
                font-size: 27px;
            }
        }
    }
</style>